export const useListingCardCarouselSize = () => {
    const itemWidth = 256;
    const itemGutter = 16;

    return {
        itemWidth,
        itemGutter,
        totalItemWidth: itemWidth + itemGutter,
    };
};
